import { PermissionGuard } from '@/ui/components/permissionGuard/PermissionGuard';
import { PurchaseOrdersManageableItemsListTable } from '@/ui/components/purchaseOrdersManageableItemsListTable/PurchaseOrdersManageableItemsListTable';
import { ManageableItemsList } from '@payaca/ambrosia';

import { MaterialsListPermissions } from '@payaca/permissions/materialsList/materialsList.permissions';
import * as materialsListActions from '@payaca/store/materialsList/materialsListActions';
import { MaterialsList } from '@payaca/types/materialsListTypes';
import { useQueryClient } from '@tanstack/react-query';
import { FC, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import projectKeys from '../../../../../api/queries/project/keyFactory';
import useGetProjectPurchaseOrders from '../../../../../api/queries/project/useGetProjectPurchaseOrders';
import { usePaginationState } from './materialsPanelHooks';

const PAGE_SIZE = 25;

export const PurchaseOrdersPanel: FC<{
  projectId: string;
  materialsListId: MaterialsList['id'];
  onUpdate?: () => void;
}> = ({ projectId, materialsListId, onUpdate }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleGetMaterialsListWithRelatedEntities = useCallback(
    (materialsListId: number) => {
      dispatch(
        materialsListActions.requestGetMaterialsListWithRelatedEntities(
          materialsListId
        )
      );
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useCallback has a missing dependency: 'dispatch'
    []
  );

  useEffect(() => {
    handleGetMaterialsListWithRelatedEntities(materialsListId);
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'materialsListId', and 'handleGetMaterialsListWithRelatedEntities'
  }, []);

  const { pagination, setCurrentPage } = usePaginationState(PAGE_SIZE);

  const { purchaseOrders, refetch } = useGetProjectPurchaseOrders({
    projectId,
    pagination,
  });

  return (
    <div className="@container">
      <PermissionGuard
        renderIfHasPermissions={[MaterialsListPermissions.GET_PURCHASE_ORDERS]}
      >
        <PurchaseOrdersManageableItemsListTable
          purchaseOrders={purchaseOrders?.items || []}
          isLoading={!purchaseOrders}
          includedColumns={[
            'ref',
            'status',
            'supplier',
            'purchase-cost',
            'forecast-cost',
          ]}
          returnToProjectOnBackNav
          onUpdateSuccess={() => {
            onUpdate?.();
            void queryClient.invalidateQueries({
              queryKey: projectKeys.purchaseOrders(projectId),
            });
          }}
        ></PurchaseOrdersManageableItemsListTable>
        {purchaseOrders && (
          <ManageableItemsList.PaginationBar
            type="custom"
            totalItems={purchaseOrders.totalCount}
            pageSize={purchaseOrders.limit}
            currentPage={purchaseOrders.offset / purchaseOrders.limit + 1}
            onPageChange={setCurrentPage}
          />
        )}
      </PermissionGuard>
    </div>
  );
};
